var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1200px",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider'), _c('v-sheet', {
    staticClass: "fill-height ",
    attrs: {
      "height": "800px",
      "elevation": "0"
    }
  }, [_c('company-map', {
    ref: "map",
    staticClass: "fill-height flex-grow-1",
    attrs: {
      "search": _vm.search,
      "filter": _vm.filter,
      "hideFilter": true
    },
    on: {
      "select": _vm.selectCompany
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }